// extracted by mini-css-extract-plugin
export default {"scaffold":"l_header_m_scaffold__s5ISF","f20w700white":"l_header_m_f20w700white__4G0Gg"};